export default {
  src: 'https://widgets.aviakassa.com/partner.js',
  aviaTitle: 'Поиск дешевых авиабилетов',
  channelToken: '188be0f1aa4df01a48839d0a1b842c496df54cb7',
  id: 1636,
}
